import { render, staticRenderFns } from "./footeralt.vue?vue&type=template&id=7d3c818c&"
import script from "./footeralt.vue?vue&type=script&lang=js&"
export * from "./footeralt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Kirbylink: require('/opt/build/repo/components/kirbylink.vue').default})
